import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import InfoIcon from '../InfoIcon';
import FollowBook from '../FollowBook';
import PremiumFeature from '../../shared/PremiumFeature';
import Spinner from '../../shared/_Spinner';
import connect from 'react-redux/es/connect/connect';

const IndexRow = function(props) {
  const { book } = props;

  return (
    <React.Fragment>
      <div className={ 'rep-books-index__container' }>
        <div className={ 'rep-books-index__icons' }>
          <InfoIcon bookId={ book.get('id') }  />
          <FollowBook bookId={ book.get('id') }  customClass={ 'follow--list-element' } followed={ book.get('followed') } />
        </div>
        <Link className='rep-books-index__list__row'
          to={ `/reps/books/${book.get('id')}/appointments` }>
          <div className='rep-books-index__list__column rep-books-index__list__column--office'>
            { book.get('name') }
          </div>

          <div className='rep-books-index__list__column rep-books-index__list__column--apts'>
            { book.get('openAppointmentsCount') }
          </div>

          <div className='rep-books-index__list__column rep-books-index__list__column--action'>
            <i className='fa fa-angle-right' />
          </div>
        </Link>
      </div>
    </React.Fragment>
  );
};

IndexRow.propTypes = {
  book: PropTypes.instanceOf(Immutable.Map)
};

export default IndexRow;



// WEBPACK FOOTER //
// ./app/components/reps/books/_IndexRow.jsx